var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.uniqueKey,staticClass:"text",class:_vm.config.jumpPanelSn ? 'has-jump':'',style:({
       textAlign: _vm.config.chartSet.titleStyle.align,
       fontSize: _vm.config.chartSet.titleStyle.fontSize + 'px',
       color: _vm.config.chartSet.titleStyle.color
     })},[(_vm.borderImgUrl)?_c('img',{staticClass:"text-border",style:({
         display:'inline-block',
         width:'100%',
         height: '100%'
       }),attrs:{"src":_vm.borderImgUrl,"alt":""}}):_vm._e(),_c('div',{staticClass:"text-block",style:({lineHeight: _vm.config.chartHeight+ 'px'})},[_vm._v(" "+_vm._s(_vm.config.chartTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }